import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ServerNameInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const serverName = event.headers.get('X-Server-Name');
          if (serverName) {
            console.log('API response from:', serverName);

            // store it somewhere/ set serverName to local storage
            localStorage.setItem("X-Server-Name", serverName);
          }
        }
      })
    );
  }
}
